export const environment = {
  production: false,
  apiUrl: 'https://development-api.thehuro.com',
  environmentName: 'development',
  portal: 'corporate',
  facilityPortalUrl: 'https://dev-facility.thehuro.com',
  stripePublishableKey:
    'pk_test_51T0QbUDWOyJZsahHyP2M4hcbJb0xtVoDc8V2qkwy6w8hRlc1865ASrC7AH7DUBqtkItTIk4m7eSKh1tjhBjeDcMK001JkcaJGW'
};

